import { Alert } from '@tvg/fuse/alert';
import React from 'react';
import styles from './NoResultsAlert.module.css';

function NoResultsAlert() {
  return (
    <div className={styles.noResultsAlert}>
      <Alert
        heading="No matching results"
        message="The filters you've applied don't return any matching products. Please change your selection."
        showIcon
        variant="information"
        role="alert"
      />
    </div>
  );
}

export default NoResultsAlert;
